import { Button, TextField } from '@ads/components-react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface SerieVideoSearchBarProps {
  readonly defaultValue: string;
  readonly onSearch: (query: string) => void;
  readonly onClear: () => void;
}

/**
 * Barra de busca da listagem de Vídeos de uma Série. Busca **server-side**
 * (`GET /api/v1/serievideo/series/{serieId}?search=`).
 */
export function SerieVideoSearchBar({ defaultValue, onSearch, onClear }: SerieVideoSearchBarProps) {
  const { t } = useTranslation('series');
  const [pending, setPending] = useState(defaultValue);

  const handleSearch = () => onSearch(pending.trim());

  const handleClear = () => {
    setPending('');
    onClear();
  };

  return (
    <div className="rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-xxs shadow-level1">
      <form
        className="flex flex-col items-start gap-nano"
        onSubmit={e => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <TextField
          label={t('videos.search.label')}
          placeholder={t('videos.search.placeholder')}
          value={pending}
          size="md"
          fullWidth
          leadingIcon={MagnifyingGlassIcon}
          onChange={e => setPending(e.target.value)}
        />
        <div className="flex items-center gap-nano">
          <Button type="submit" hierarchy="primary" size="md" leadingIcon={MagnifyingGlassIcon}>
            {t('videos.search.button')}
          </Button>
          <Button type="button" hierarchy="secondary" size="md" onClick={handleClear}>
            {t('videos.search.clear')}
          </Button>
        </div>
      </form>
    </div>
  );
}
